<template>
  <div :class='componentClasses'>
    <div class='result-wrapper'>
      <h3 class="subheading">Response UUID</h3>
      {{ responseUUID }}
      <h3 class="subheading">Persistent Result URL</h3>
      {{ resultURL }}
      <h3 class="subheading">Respondent info</h3>
      {{ signup }}
      <h3 class="subheading">Response data</h3>
      {{answers}}
      <h3 class="subheading">Session data</h3>
      {{session}}
      <h3 class="subheading">Status</h3>
      {{status}}
    </div>
  </div>
</template>
<script>
import Velocity from 'velocity-animate'
import { mapState } from 'vuex'
export default {
  props: {
    config: {type: Object, default: () => {}},
    result: {type: Object, default: () => {}}
  },
  data () {
    return {
      componentClasses: ['result-custom-component', 'result-component'],
    }
  },
  computed: {
    ...mapState(['answers', 'signup', 'session', 'status', 'responseUUID', 'resultURL'])
  },
  methods: {
    gotoSignup () {
      this.scrollTo('result-component-2')
    },
    scrollTo (ref) {
      let tgt = document.getElementById(ref)
      if (ref) {
        Velocity.animate(
          tgt, 'scroll', 750
        )
      }
    }
  }
}
</script>
<style lang='scss' scoped></style>
